var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPetWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9928 5.99615C12.0966 5.99615 12.9914 5.10131 12.9914 3.99746C12.9914 2.89362 12.0966 1.99878 10.9928 1.99878C9.88892 1.99878 8.99408 2.89362 8.99408 3.99746C8.99408 5.10131 9.88892 5.99615 10.9928 5.99615Z",
    stroke: "white",
    strokeWidth: 1.99868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9882 9.99346C19.092 9.99346 19.9868 9.09862 19.9868 7.99478C19.9868 6.89093 19.092 5.99609 17.9882 5.99609C16.8843 5.99609 15.9895 6.89093 15.9895 7.99478C15.9895 9.09862 16.8843 9.99346 17.9882 9.99346Z",
    stroke: "white",
    strokeWidth: 1.99868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9868 17.9881C21.0907 17.9881 21.9855 17.0932 21.9855 15.9894C21.9855 14.8856 21.0907 13.9907 19.9868 13.9907C18.883 13.9907 17.9882 14.8856 17.9882 15.9894C17.9882 17.0932 18.883 17.9881 19.9868 17.9881Z",
    stroke: "white",
    strokeWidth: 1.99868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99408 9.99341C9.65025 9.99341 10.3 10.1227 10.9062 10.3738C11.5125 10.6249 12.0633 10.9929 12.5273 11.4569C12.9913 11.9209 13.3593 12.4717 13.6104 13.078C13.8615 13.6842 13.9908 14.3339 13.9908 14.9901V18.4878C13.9905 19.3237 13.6909 20.1319 13.1462 20.766C12.6014 21.4 11.8477 21.818 11.0213 21.9443C10.195 22.0705 9.35079 21.8966 8.6416 21.4541C7.93241 21.0117 7.40514 20.3298 7.15529 19.5321C6.7289 18.1564 5.82949 17.2553 4.45707 16.8289C3.65977 16.5792 2.97821 16.0523 2.53569 15.3437C2.09318 14.635 1.91895 13.7913 2.04454 12.9653C2.17013 12.1393 2.58724 11.3856 3.22039 10.8405C3.85354 10.2953 4.6609 9.99487 5.49638 9.99341H8.99408Z",
    stroke: "white",
    strokeWidth: 1.99868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetWhite);
export default __webpack_public_path__ + "static/media/petWhite.b5255698ce2ff4d2fe43cbcc15c9df88.svg";
export { ForwardRef as ReactComponent };